import { useEffect } from "react"
import UploadForm from "./UploadForm"

const UploadData = ({ open }) => {
    useEffect(() => {
        document.title = 'Upload data'
    }, [])
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <UploadForm />
        </main>
    )
}
export default UploadData;